// import packages or dependencies
import { Grid, useTheme } from "@mui/material";
import UsersTable from "./users-table/UsersTable";
import CreateUser from "./create-user/CreateUser";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  getUserManagementListAction,
  userManagement,
} from "./userManagementSlice";
import PermissionDenied from "../../global/permission-denied/PermissionDenied";
import { useEffect, useState } from "react";
import {
  authentication,
  logoutAction,
} from "../../authentication/authenticationSlice";
import LoaderContainer from "../../global/loader/LoaderContainer";
import { eraseCookie } from "../../../configs/cookie-helper/cookieHelper";
import { useNavigate } from "react-router-dom";

/**
 * @returns This component displays the main page of user management
 */
function UserManagement() {
  // states and handlers
  const theme = useTheme();

  const {
    createUser: { formIsOpen },
    userManagementData: {
      alert: { error, message },
      actionStatus,
    },
  } = useAppSelector(userManagement);

  const { token } = useAppSelector(authentication);

  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    if (!!token) {
      dispatch(getUserManagementListAction());
    }
  }, [dispatch, token]);

  const [authStatus, setAuthStatus] = useState({ message: "", loading: false });

  useEffect(() => {
    if (actionStatus === "loading") {
      setAuthStatus({ message: message, loading: true });
    }

    if (!!token && actionStatus === "success") {
      setAuthStatus({ message: message, loading: false });
    }

    if (actionStatus === "rejected") {
      setAuthStatus({ message: message, loading: false });
    }
  }, [token, actionStatus, error, message]);

  useEffect(() => {
    if (authStatus.message === "login_again") {
      eraseCookie("token");
      eraseCookie("username");
      eraseCookie("rule");
      navigate("/login");
      dispatch(logoutAction());
    }
  }, [authStatus, navigate, dispatch]);
  // render jsx
  return (
    <>
      {authStatus.loading ? (
        <LoaderContainer />
      ) : (
        <>
          {authStatus.message === "not_acssess" ? (
            <PermissionDenied />
          ) : (
            <>
              <Grid
                data-testid="create_user_component"
                item
                xs={12}
                sx={{
                  mb: "10px",
                  // height: "calc(100% - 119px)",
                  [theme.breakpoints.down("md")]: {
                    // height: "calc(100% - 102px)",
                  },
                }}
              >
                <CreateUser />
              </Grid>

              <Grid
                data-testid="users_table_component"
                item
                xs={12}
                sx={{
                  height: formIsOpen
                    ? "calc(100% - 450px)"
                    : "calc(100% - 119px)",
                  [theme.breakpoints.down("lg")]: {
                    height: formIsOpen
                      ? "calc(100% - 450px)"
                      : "calc(100% - 102px)",
                  },
                  [theme.breakpoints.down("md")]: {
                    height: formIsOpen
                      ? "calc(100% - 700px)"
                      : "calc(100% - 102px)",
                  },
                  [theme.breakpoints.down("sm")]: {
                    height: formIsOpen
                      ? "calc(100% - 650px)"
                      : "calc(100% - 102px)",
                  },
                }}
              >
                <UsersTable />
              </Grid>
            </>
          )}
        </>
      )}
    </>
  );
}

export default UserManagement;
